import { FC, JSX, useState } from "react";
import { ServicingProvider } from "@app/projects/results/servicing-provider";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";
import { SimulateProviderTermination } from "@app/projects/servicing-provider/provider-termination/SimulateProviderTermination";
import { TerminateProps, getDefaultIdentifier, WrappedTerminateProvidersPanel } from "@app/projects/servicing-provider/TerminateProvidersPanel";
import { FlyoutContextOutgoingProps, withFlyoutContext } from "@app/shared/Flyouts";
import { UserContextProps, withUserContext } from "@app/user/UserContext";

type TerminateProvidersSimulationPanelProps = TerminateProps & UserContextProps & FlyoutContextOutgoingProps &
{
  providerNetworkType: ProviderNetworkTypeEnum,
  regionSetId: number,
  isZipProject: boolean,
  error?: JSX.Element | null
};

const TerminateProvidersSimulationPanel: FC<React.PropsWithChildren<TerminateProvidersSimulationPanelProps>> = (props: TerminateProvidersSimulationPanelProps) => {
  const [allSpecialties, setAllSpecialties] = useState<boolean>(false);
  const [allLocations, setAllLocations] = useState<boolean>(false);
  const [identifier, setIdentifier] = useState<string>(getDefaultIdentifier(props.selectedProviders, null, null));
  const [hasTerminationError, setHasTerminationError] = useState<boolean>(false);

  return <div>
    <SimulateProviderTermination
      {...props}
      selectedProviders={props.selectedProviders as ServicingProvider[]}
      specialtyGroupCode={props.specialtyGroupCode}
      identifier={identifier}
      allLocations={allLocations}
      allSpecialties={allSpecialties}
      isZipProject={props.isZipProject}
      hasTerminationError={hasTerminationError}
    />
    <WrappedTerminateProvidersPanel
      onSubmit={props.onSubmit}
      projectId={props.projectId}
      selectedProviders={props.selectedProviders}
      specialtyGroupCode={props.specialtyGroupCode}
      terminatePanelMode={props.terminatePanelMode}
      setAllSpecialtiesInParent={setAllSpecialties}
      setAllLocationsInParent={setAllLocations}
      setIdentifierInParent={setIdentifier}
      setErrorInParent={setHasTerminationError}
      showAffiliationsInsights={props.showAffiliationsInsights}
      isZipProject={props.isZipProject}
    />
  </div>;
};

const WrappedTerminateProvidersSimulationPanel = withFlyoutContext(withUserContext(TerminateProvidersSimulationPanel));

export { WrappedTerminateProvidersSimulationPanel };
